import { render, staticRenderFns } from "./product-stock-history.vue?vue&type=template&id=79d07e78&"
import script from "./product-stock-history.vue?vue&type=script&lang=js&"
export * from "./product-stock-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports